module.exports = __webpack_public_path__ + "static/media/logolinkedinfooter.907e0afe.svg";